import {FmlxModal} from "fmlx-common-ui";

const EssModal = ({ open, title, Size, hideCloseButton,onClose, customFooter,succesButton, rejectButton, children, footerButtons}) => (
  <FmlxModal
    open={open}
    size={FmlxModal.Size.LARGE || Size}
    title={title}
    hideCloseButton={hideCloseButton}
    onCloseClick={onClose}
    customFooter={footerButtons}
    primaryButton={succesButton}
    secondaryButton={rejectButton}
  >
    <div className="modal-content">{children}</div>
  </FmlxModal>
);

export default EssModal;
